import React from 'react';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import * as Utils from '../../commons/utils/Utils';
import { FormattedMessage } from 'react-intl';
import { FaInfoCircle } from 'react-icons/fa'; // Importa un ícono de información
import LocaleFormat from '../../commons/utils/LocaleFormat.js';

const PresupuestoDetail = ({ presupuesto, relacion }) => {
    const [totalAsignado, setTotalAsignado] = useState(0);
    const [distribuido, setDistribuido] = useState(0);
    const [comprometido, setComprometido] = useState(0);
    const [consumido, setConsumido] = useState(0);
    const [disponible, setDisponible] = useState(0);
    const [loading, setLoading] = useState(true);

    const formatCurrency = (value) => {
        return new Intl.NumberFormat(LocaleFormat.getNumberLocale(), { style: 'currency', currency: 'ARS' }).format(value);
    };

    const calcularPresupuestos = () => {
        const { monto_general = 0, monto_correctivo = 0, monto_preventivo = 0, monto_gestoria = 0, monto_vencimientos = 0 } = presupuesto;
        const total = monto_general + monto_correctivo + monto_preventivo + monto_gestoria + monto_vencimientos;
        setTotalAsignado(total);
        obtenerPresupuestoResumen(relacion.id, presupuesto.periodo.id, relacion.presupuestable,total);
    };

    const obtenerPresupuestoResumen = async (id, periodoId, presupuestableType , total) => {
        try {
            const response = await Utils.getData(`/presupuestos/presupuesto-resumen/${id}?periodoId=${periodoId}&presupuestableType=${presupuestableType}`);
            setDistribuido(parseFloat(response.distribuido) || 0);
            setComprometido(parseFloat(response.comprometido) || 0);
            setConsumido(parseFloat(response.consumido) || 0);
            let presupuestoDisponible = parseFloat(total) - parseFloat(response.distribuido);
            if (relacion.modulo === 'bases') {
                presupuestoDisponible = parseFloat(total) - (parseFloat(response.comprometido) + parseFloat(response.consumido));
            }
            setDisponible(presupuestoDisponible);
        } catch (error) {
            console.error('Error al obtener el resumen del presupuesto:', error);
            return null;
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        calcularPresupuestos();
    }, [presupuesto, relacion]);

    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: '#f9f9f9', width: '100%' }}>
            <div style={{ margin: '10px', padding: '20px', backgroundColor: '#ffffff', border: '1px solid rgb(0, 191, 188)', borderRadius: '10px', width: '95%', textAlign: 'center', boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)' }}>
                <h2 style={{ marginBottom: '20px', color: 'rgb(0, 191, 188)', fontSize: '20px', textAlign:'left' }}>{presupuesto.periodo.nombre}</h2>
                <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '16px', tableLayout: 'fixed' }}>
                    <tbody>
                        <tr>
                            <td 
                                style={{ padding: '10px', fontWeight: 'bold', textAlign: 'left', whiteSpace: 'nowrap' }}
                            >
                                <FormattedMessage id="presupuestoDetail.presupuesto_table.column_fecha_inicio" defaultMessage="Fecha de inicio" />
                            </td>
                            <td style={{ padding: '10px', textAlign: 'left', whiteSpace: 'nowrap' }}>{presupuesto.periodo ? presupuesto.periodo.fecha_inicio : 'N/A'}</td>
                        </tr>
                        <tr>
                            <td 
                                style={{ padding: '10px', fontWeight: 'bold', textAlign: 'left', whiteSpace: 'nowrap' }}
                            >
                                <FormattedMessage id="presupuestoDetail.presupuesto_table.column_fecha_fin" defaultMessage="Fecha de fin" />
                            </td>
                            <td style={{ padding: '10px', textAlign: 'left', whiteSpace: 'nowrap' }}>{presupuesto.periodo ? presupuesto.periodo.fecha_fin : 'N/A'}</td>
                        </tr>
                        <tr>
                            <td 
                                style={{ padding: '10px', fontWeight: 'bold', textAlign: 'left', whiteSpace: 'nowrap' }}
                            >
                                <FormattedMessage id="presupuestoDetail.presupuesto_table.column_total_asignado" defaultMessage="Presupuesto total" />
                                <FaInfoCircle
                                    title={ <FormattedMessage id="presupuestoDetail.presupuesto_table.column_total_asignado_info" 
                                                              defaultMessage="Es el monto total del periodo" /> }
                                    style={{ marginLeft: '5px', color: 'rgb(0, 191, 188)', cursor: 'pointer' }}
                                />
                            </td>
                            <td style={{ padding: '10px', textAlign: 'left', whiteSpace: 'nowrap' }}>{formatCurrency(totalAsignado) || 'N/A'}</td>
                        </tr>
                        {relacion.modulo !== 'bases' && (
                        <tr>
                            <td 
                                style={{ padding: '10px', fontWeight: 'bold', textAlign: 'left', whiteSpace: 'nowrap' }}
                            >
                                <FormattedMessage id="presupuestoDetail.presupuesto_table.column_total_distribuido" defaultMessage="Presupuesto distribuido" />
                                <FaInfoCircle
                                    title={ <FormattedMessage id="presupuestoDetail.presupuesto_table.column_total_distribuido_info" 
                                        defaultMessage="Es el monto ya asignado a las subregiones o bases." /> }
                                    style={{ marginLeft: '5px', color: 'rgb(0, 191, 188)', cursor: 'pointer' }}
                                />
                            </td>
                            <td style={{ padding: '10px', textAlign: 'left', whiteSpace: 'nowrap' }}>{formatCurrency(distribuido) || 'N/A'}</td>
                        </tr>
                        )}
                        {relacion.modulo == 'bases' && (
                        <tr>
                            <td 
                                style={{ padding: '10px', fontWeight: 'bold', textAlign: 'left', whiteSpace: 'nowrap' }}
                                title="El monto total consumido dentro del presupuesto asignado"
                            >
                                <FormattedMessage id="presupuestoDetail.presupuesto_table.column_total_comprometido" defaultMessage="Presupuesto comprometido" />
                                <FaInfoCircle
                                    title={ <FormattedMessage id="presupuestoDetail.presupuesto_table.column_total_comprometido_info" 
                                        defaultMessage="Es el monto total de los prespuestos de tickets aprobados sin cerrar" /> }
                                    style={{ marginLeft: '5px', color: 'rgb(0, 191, 188)', cursor: 'pointer' }}
                                />
                            </td>
                            <td style={{ padding: '10px', textAlign: 'left', whiteSpace: 'nowrap' }}>{formatCurrency(comprometido) || 'N/A'}</td>
                        </tr>
                        )}
                        {relacion.modulo == 'bases' && (
                        <tr>
                            <td 
                                style={{ padding: '10px', fontWeight: 'bold', textAlign: 'left', whiteSpace: 'nowrap' }}
                                title="El monto total consumido dentro del presupuesto asignado"
                            >
                                <FormattedMessage id="presupuestoDetail.presupuesto_table.column_total_consumido" defaultMessage="Presupuesto consumido" />
                                <FaInfoCircle
                                    title={ <FormattedMessage id="presupuestoDetail.presupuesto_table.column_total_consumido_info" 
                                        defaultMessage="Es el monto total de los presupuestos de tickets cerrados" /> }
                                    style={{ marginLeft: '5px', color: 'rgb(0, 191, 188)', cursor: 'pointer' }}
                                />
                            </td>
                            <td style={{ padding: '10px', textAlign: 'left', whiteSpace: 'nowrap' }}>{formatCurrency(consumido) || 'N/A'}</td>
                        </tr>
                        )}
                        {relacion.modulo !== 'bases' ? (
                        <tr>
                            <td 
                                style={{ padding: '10px', fontWeight: 'bold', textAlign: 'left', whiteSpace: 'nowrap' }}
                                title="El monto disponible restante dentro del presupuesto asignado"
                            >
                                <FormattedMessage id="presupuestoDetail.presupuesto_table.column_total_disponible" defaultMessage="Presupuesto disponible" />
                                <FaInfoCircle
                                    title={ <FormattedMessage id="presupuestoDetail.presupuesto_table.column_total_disponible_info" 
                                        defaultMessage="Es la diferencia entre el monto total y el ya asignado a las subregiones o bases." /> }
                                    style={{ marginLeft: '5px', color: 'rgb(0, 191, 188)', cursor: 'pointer' }}
                                />
                            </td>
                            <td style={{ padding: '10px', textAlign: 'left', whiteSpace: 'nowrap' }}>{formatCurrency(disponible) || 'N/A'}</td>
                        </tr>
                        ) : (
                        <tr>
                            <td 
                                style={{ padding: '10px', fontWeight: 'bold', textAlign: 'left', whiteSpace: 'nowrap' }}
                                title="El monto disponible restante dentro del presupuesto asignado"
                            >
                                <FormattedMessage id="presupuestoDetail.presupuesto_table.column_total_disponible" defaultMessage="Presupuesto disponible" />
                                <FaInfoCircle
                                    title={ <FormattedMessage id="presupuestoDetail.presupuesto_table.column_total_disponible_info" 
                                        defaultMessage="Es la diferencia entre el monto total y la suma entre el monto comprometido y consumido" /> }
                                    style={{ marginLeft: '5px', color: 'rgb(0, 191, 188)', cursor: 'pointer' }}
                                />
                            </td>
                            <td style={{ padding: '10px', textAlign: 'left', whiteSpace: 'nowrap' }}>{formatCurrency(disponible) || 'N/A'}</td>
                        </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

PresupuestoDetail.propTypes = {
    presupuesto: PropTypes.object.isRequired,
};

export default PresupuestoDetail;